import {Injectable} from '@angular/core';
import {HttpService} from './http.service';

@Injectable()
export class NotificationService {
  constructor(private http: HttpService) {
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/notification.service.ts